import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/HomeView.vue'
import Test from '../views/test.vue'
import Login from "../views/Login.vue"
// import store from '@/store'
import Register from "../views/Register.vue"
// 引入子页面
import HomeView from "../views/modules/home";
import { userCount } from '@/tool'
import store from '@/store'
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    redirect: "/home",
    children: [
      // 首页
      {
        path: '/home',
        name: 'homeView',
        component: HomeView,
        meta: { title: '首页', isCount: true,keepAlive: true  },
      },
        // 期刊速递详情
      {
        path: '/paperDetail',
        name: 'paperDetail',
        component: () => import('../views/modules/paperDetail'),
        meta: { title: '期刊详情', isCount: true },
      },
      // pdf提取
      {
        path: '/pdf/extract/:id',
        name: 'pdfExtract',
        component: () => import('../views/toolView/pdfExtract'),
        meta: { title: '文献提取', isCount: true },
      },
      // 原位文章详情
      {
        path: '/professionalDetail',
        name: 'professional Detail',
        component: () => import('../views/modules/professionalDetail'),
        meta: { title: '专业测试详情', isCount: true },
      },
      {
        path: 'deposit',
        name: 'deposit',
        meta: { title: '预存页面', isCount: true },
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/deposit')
      },
      // 合作洽谈表单
      {
        path: '/cooperate',
        name: 'cooperate',
        component: () => import('../views/modules/cooperate'),
        meta: { title: '合作洽谈', isCount: true },
      },
      // 期刊速递列表
      {
        path: '/journalList',
        name: 'journalList',
        component: () => import('../views/modules/journalList'),
        meta: { title: '期刊速递', isCount: true },
      },

      // 限时领券
      {
        path: '/receiveCoupon',
        name: 'receiveCoupon',
        component: () => import('../views/modules/receiveCoupon'),
        meta: { title: '限时领取', isCount: true },
      },
       // 活动专区
       {
        path: '/activityArea',
        name: 'activityArea',
        component: () => import('../views/modules/activityArea'),
        meta: { title: '活动专区', isCount: true },
      },

      // 限时秒杀
      {
        path: '/flashSale',
        name: 'flashSale',
        component: () => import('../views/childrenView/flashSale')
      },
      // 评价活动
      {
        path: '/evaluate',
        name: 'evaluate',
        component: () => import('../views/childrenView/evaluate')
      },

      // 首页
      {
        path: '/category',
        name: 'categoryView',
        component: () => import(/* webpackChunkName: "about" */ '../views/categoryView/index'),
        meta: { title: '分类', isCount: true },

      },
      // //测试分类
      // {
      //   path: 'testClass',
      //   name: 'testClass',
      //   redirect: "/testClass/allTestClass",
      //   component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/testClassView'),
      //   children: [
      //     // 全部测试
      //     {
      //       path: 'allTestClass',
      //       name: 'allTestClass',
      //       meta: { title: '全部测试', isCount: true },
      //       component: () => import(/* webpackChunkName: "about" */ '../views/testClassView/allTestClass')
      //     },
      //     // 高端测试
      //     {
      //       path: 'highEndTest',
      //       name: 'highEndTest',
      //       meta: { title: '高端测试', isCount: true },
      //       component: () => import(/* webpackChunkName: "about" */ '../views/testClassView/highEndTest1')
      //     },
      //     // 常规测试
      //     {
      //       path: 'routineTest',
      //       name: 'routineTest',
      //       meta: { title: '常规测试', isCount: true },
      //       component: () => import(/* webpackChunkName: "about" */ '../views/testClassView/routineTest')
      //     },
      //     // 云现场
      //     {
      //       path: 'cloudSite',
      //       name: 'cloudSite',
      //       meta: { title: '云现场', isCount: true },

      //       component: () => import(/* webpackChunkName: "about" */ '../views/testClassView/cloudSite')
      //     },
      //     // 其他测试
      //     {
      //       path: 'otherTest',
      //       name: 'otherTest',
      //       meta: { title: '其他测试', isCount: true },

      //       component: () => import(/* webpackChunkName: "about" */ '../views/testClassView/otherTest')
      //     },
      //     // 数据解析

      //     // {
      //     //   path: 'dataAnalysis',
      //     //   name: 'dataAnalysis',
      //     //   component: () => import(/* webpackChunkName: "about" */ '../views/testClassView/dataAnalysis')
      //     // },
      //   ]
      // },
      // 同步辐射
      {
        path: 'syncRdiation',
        name: 'syncRdiation',
        meta: { title: '同步辐射', isCount: true },

        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/syncRdiationView')
      },
      // 球差电镜
      {
        path: 'acTem',
        name: 'acTem',
        meta: { title: '球差电镜', isCount: true },

        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/acTemView')
      },
      // 原位测试
      {
        path: 'situTest',
        name: 'situTest',
        meta: { title: '原位测试', isCount: true },

        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/situTestView')
      },
      // 纳米材料
      {
        path: 'nmMaterial',
        name: 'nmMaterial',
        meta: { title: '纳米材料', isCount: true },

        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/nmMaterialView')
      },

      // 计算模拟
      {
        path: 'cptSimulation',
        name: 'cptSimulation',
        meta: { title: '计算模拟', isCount: true },

        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/cptSimulationView')
      },
      // 计算模拟的商品页面
      {
        path: 'cptGoodsView',
        name: 'cptGoodsView',
        // meta: { title: '计算模拟', isCount: true },

        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/cptGoodsView')
      },

      //学研课堂
      {
        path: 'classroom',
        name: 'classroom',
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/classroomView')
      },
      // 数据解析
      {
        path: 'dataAnalysis',
        name: 'dataAnalysis',
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/dataAnalysis')
      },
      {
        path: 'scientificVisualization',
        name: 'scientificVisualization',
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/scientificVisualization')
      },

      // 安全评估
      {
        path: 'risk',
        name: 'risk',
        component: () => import(/* webpackChunkName: "about" */ '../views/categoryView/riskView')
      },
      // 搜索结果页面
      {
        path: 'searchResult',
        name: 'searchResult',
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/searchResult')
      },
      // 更多套餐
      {
        path: 'morePackages',
        name: 'morePackages',
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/morePackages')
      },
      // 商品详情
      {
        path: 'details/:id',
        name: 'details',
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/detailsView')
      },
      // 套餐详情
      {
        path: 'groupDetail/:id',
        name: 'groupDetail',
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/groupDetail')
      },
      // 纳米材料详情
      {
        path: 'nmMaterialDetail/:id',
        name: 'nmMaterialDetail',
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/nmMaterialDetail')
      },
      // 拼团详情
      {
        path: 'packageDetail/:id',
        name: 'packageDetail',
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/packageDetail')
      },
      // 预约下单
      {
        path: 'placeOrderView/:id',
        name: 'placeOrderView',
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/placeOrderView'),

      },
      // 订单确认
      {
        path: 'orderConfirm/:id',
        name: "orderConfirm",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/orderConfirm'),

      },
      // 支付页面
      {
        path: "pay",
        name: "pay",

        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/payView'),
      },
      // 补差价支付

      {
        path: "spreadMoneyPay",
        name: "spreadMoneyPay",

        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/spreadMoneyPay'),
      },
      // 还款支付页面
      {
        path: "repay",
        name: "repay",

        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/repayView'),
      },
      // 支付结果
      {
        path: "payResult",
        name: "payResult",
        component: () => import(/* webpackChunkName: "about" */ '../views/resultView/payResult')
      },
      // 实名认证结果
      {
        path: "authResult",
        name: "authResult",
        component: () => import(/* webpackChunkName: "about" */ '../views/resultView/authResult')
      },
      // 购物车
      {
        path: "shopCar",
        name: "shopCar",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/shopCar'),

      },
      // 草稿箱
      {
        path: "drafts",
        name: "drafts",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/drafts'),
      },
      {
        path: "/test",
        name: "test",
        component: Test
      },
      // 发布需求
      {
        path: "releaseDemand",
        name: "releaseDemand",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/releaseDemand')
      },

      // 预存页面
      {
        path: "preStorage",
        name: "preStorage",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/preStorage')

      },
      //预存静态页面
      {
        path: "preStorageStatic",
        name: "preStorageStatic",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/preStorageStatic')

      },
      // 提交审核成功页面
      {
        path: "submitInfo",
        name: "submitInfo",
        component: () => import(/* webpackChunkName: "about" */ '../views/resultView/submitInfo')

      },
      // 对公转账预存信息页面
      {
        path: "preStoExamine",
        name: "preStoExamine",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/preStoExamine')

      },
      // 测试订单详情页
      {
        path: "testOrderDetail",
        name: "testOrderDetail",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/testOrderDetail')
      },
      // 商城订单详情页
      {
        path: "mallOrderDetail/:id",
        name: "mallOrderDetail/:id",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/mallOrderDetail')
      },
      // 套餐订单详情页
      {
        path: "packageOrderDetail/:id",
        name: "packageOrderDetail/:id",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/packageOrderDetail')
      },
      //申请开票页面
      {
        path: "invoiceDetail",
        name: "invoiceDetail",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/invoiceDetail')
      },
      // 售后页面
      {
        path: "afterSalesView",
        name: "afterSalesView",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/afterSalesView'),
      },
      // 售后退款页面
      {
        path: "afterSalesDrawback",
        name: "afterSalesDrawback",
        component: () => import(/* webpackChunkName: "about" */ '../views/afterSalesView/drawback'),
      },
      // 售后复测页面
      {
        path: "afterSalesRetest",
        name: "afterSalesRetest",
        component: () => import(/* webpackChunkName: "about" */ '../views/afterSalesView/retest'),
      },
      // 查看评论页面
      {
        path: "viewComment",
        name: "viewComment",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/viewComment'),
      },
      // 关于我们
      {
        path: "aboutUs",
        name: "aboutUs",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/aboutUs'),
      },
      // 申请会员页面
      {
        path: "applyVip",
        name: "applyVip",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/applyVipView1'),
      },
      {
        path: "applyVip1",
        name: "applyVip1",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/applyVipView1'),
      },
      // 了解会员
      {
        path: "understandMember",
        name: "understandMember",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/understandMember'),
      },
      // 会员中心
      {
        path: "memberCenter",
        name: "memberCenter",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/memberCenter'),
      },
      // 开通平台支付
      {
        path: "openPayment",
        name: "openPayment",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/openPayment'),
      },
      // 服务条款
      {
        path: "serviceClause",
        name: "serviceClause",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/serviceClause'),
      },
      // 文献求助
      {
        path: 'literatureHelp',
        name: 'literatureHelp',
        meta: { title: '文献求助',isCount: true },
        component: () => import('../views/literatureHelpView/literatureHelp')
      },

      {
        path: 'liebianDetail/:id',
        name: 'liebianDetail',
        meta: { title: '裂变详情' },
        component: () => import('../views/literatureHelpView/liebianDetail')
      },
      // 求助详情
      {
        path: 'helpDetail',
        name: 'helpDetail',
        component: () => import('../views/literatureHelpView/helpDetail')
      },
      // 求助记录
      {
        path: 'helpRecords',
        name: 'helpRecords',
        component: () => import('../views/literatureHelpView/helpRecords')
      },
      // 优惠券商品页
      {
        path: 'testCoupon',
        name: 'testCoupon',
        component: () => import('../views/activityView/testCoupon')
      },
      // 新手引导页面
      {
        path: 'guideView',
        name: 'guideView',
        component: () => import('../views/childrenView/guideView')
      },
      // IF查询
      {
        path: 'IFQueryView',
        name: 'IFQueryView',
        component: () => import('../views/childrenView/IFQueryView')
      },
      // 分区查询
      {
        path: 'partitionQueryView',
        name: 'partitionQueryView',
        component: () => import('../views/childrenView/partitionQueryView')
      },
      // 消息历史记录
      {

        path: 'messageHistory',
        name: 'messageHistory',
        component: () => import('../views/childrenView/messageHistory')
      },
      // 更换负责人
      {

        path: 'replaceHeadman',
        name: 'replaceHeadman',
        component: () => import('../views/myCenterView/teamView/replaceHeadman')
      },
      //论文致谢
      {

        path: 'paperThank',
        name: 'paperThank',
        component: () => import('../views/childrenView/paperThank')
      },
      // 纳米材料免费送 活动页面
      {
        path: "freeDeliveryNano",
        name: "freeDeliveryNano",
        component: () => import('@/views/activityView/freeDeliveryNano')

      },
      // 下载原位拉曼文献
      {
        path: "downloadViewy1",
        name: "downloadViewy1",
        component: () => import('@/views/activityView/downloadViewy1')
      },
      // 下载同步辐射文献
      {
        path: "downloadViewt1",
        name: "downloadViewt1",
        component: () => import('@/views/activityView/downloadViewt1')
      },
      // 下载三合一文献
      {
        path: "downloadViews1",
        name: "downloadViews1",
        component: () => import('@/views/activityView/downloadViews1')
      },
      // 下载原位红外科研读物
      {
        path: "downloadViewyd1",
        name: "downloadViewyd1",
        component: () => import('@/views/activityView/downloadViewyd1')
      },

      // 预存活动页面
      {
        path: "preStorageActivity",
        name: "preStorageActivity",
        component: () => import('@/views/activityView/preStorageActivity')

      },
      // 临时活动
      {
        path: "tempActivity",
        name: "tempActivity",
        component: () => import('@/views/activityView/tempActivity')

      },
      // 下单有礼活动
      {
        path: "placeOrderActivity",
        name: "placeOrderActivity",
        component: () => import('@/views/activityView/placeOrderActivity')

      },
      // 毕业季
      {
        path: "graduationSeason",
        name: "graduationSeason",
        component: () => import('@/views/activityView/graduationSeason')

      },
      // 个人中心
      {
        path: "myCenter",
        name: "myCenter",
        component: () => import(/* webpackChunkName: "about" */ '../views/childrenView/myCenter'),
        meta: { loginRequest: true },
        children: [
          // 我的首页
          {
            name: "centerHome",
            path: "centerHome",
            meta: { title: '个人中心首页', isCount: true },
            component: () => import("../views/myCenterView/centerHome"),

          },
          // 个人资料
          {
            name: "personalData",
            path: "personalData",
            meta: { title: '个人资料', isCount: true },


            component: () => import("../views/myCenterView/personalData"),
          },
          // 寄件地址
          {
            name: "address",
            path: "address",


            component: () => import("../views/myCenterView/address")
          },
          // 绑定&安全
          {
            name: "security",
            path: "security",
            meta: { title: '绑定&安全', isCount: true },

            component: () => import("../views/myCenterView/security"),
          },
          // 我的钱包
          {
            name: "wallet",
            path: "wallet",
            meta: { title: '我的钱包', isCount: true },

            component: () => import("../views/myCenterView/wallet")
          },
          {
            name: "myFlashSale",
            path: "myFlashSale",
            component: () => import("../views/myCenterView/myFlashSale")
          },
          // 优惠券
          {
            name: "coupon",
            path: "coupon",
            meta: { title: '优惠券', isCount: true },

            component: () => import("../views/myCenterView/coupon")
          },
          {
            name: "promoCode",
            path: "promoCode",
            meta: { title: '优惠码', isCount: true },

            component: () => import("../views/myCenterView/promoCode")
          },
          // 积分
          {
            name: "integral",
            path: "integral",
            component: () => import("../views/myCenterView/integral")
          },
          // 红包
          {
            name: "redBag",
            path: "redBag",
            component: () => import("../views/myCenterView/redBag")
          },
          // 我的订单
          {
            name: "myOrders",
            path: "myOrders",
            meta: { title: '我的订单', isCount: true },

            component: () => import("../views/myCenterView/myOrders")
          },
          // 售后列表
          {
            name: "afterSaleList",
            path: "afterSaleList",
            meta: { title: '售后列表', isCount: true },

            component: () => import("../views/myCenterView/afterSaleList")
          },
          // 评论晒单
          {
            name: "comment",
            path: "comment",
            meta: { title: '评论晒单', isCount: true },

            component: () => import("../views/myCenterView/comment")
          },
          // 我的收藏
          {
            name: "myCollection",
            path: "myCollection",
            meta: { title: '我的收藏', isCount: true },

            component: () => import("../views/myCenterView/myCollection")
          },
          // 常购项目
          {
            name: "oftenBy",
            path: "oftenBy",

            component: () => import("../views/myCenterView/oftenBy")
          },
          // 申请开票
          {
            name: "applyInvoice",
            path: "applyInvoice",
            meta: { title: '申请开票', isCount: true },

            component: () => import("../views/myCenterView/applyInvoice")
          },
          // 发票信息管理
          {
            name: "invoiceInfoAdmin",
            path: "invoiceInfoAdmin",
            meta: { title: '发票信息管理', isCount: true },

            component: () => import("../views/myCenterView/invoiceInfoAdmin")
          },
          // 发票信息列表
          {
            name: "invoiceList",
            path: "invoiceList",
            meta: { title: '发票信息列表', isCount: true },

            component: () => import("../views/myCenterView/invoiceList")
          },
          // 已开发票列表
          {
            name: "invoicedList",
            path: "invoicedList",
            meta: { title: '发票信息列表', isCount: true },

            component: () => import("../views/myCenterView/invoicedList")
          },
          // 预存申请单列表
          {
            name: "preDepositApply",
            path: "preDepositApply",
            // meta: { title: '预存申请单', isCount: true },
            component: () => import("../views/myCenterView/preDepositApply")
          },
          // 创建团队
          {
            name: "addTeam",
            path: "addTeam",
            component: () => import("../views/myCenterView/teamView/addTeamView")
          },
          // 加入团队
          {
            name: "joinTeam",
            path: "joinTeam",
            component: () => import("../views/myCenterView/teamView/joinTeamView")
          },
          // 我的团队
          {
            name: "myTeam",
            path: "myTeam",
            component: () => import("../views/myCenterView/teamView/myTeam"),
            meta: { isCheck: true }

          },
          // 团队信息
          {
            name: "teamInfo",
            path: "teamInfo",
            component: () => import("../views/myCenterView/teamView/teamInfo"),
            meta: { isCheck: true }


          },
          // 团队成员管理

          {
            name: "teamMemberAdmin",
            path: "teamMemberAdmin",
            component: () => import("../views/myCenterView/teamView/teamMemberAdmin"),
            meta: { isCheck: true }


          },
          // 团队成员
          {
            name: "teamMemberInfo",
            path: "teamMemberInfo",
            component: () => import("../views/myCenterView/teamView/teamMemberInfo"),
            meta: { isCheck: true }


          },
          // 团队订单管理
          {
            name: "teamOrderAdmin",
            path: "teamOrderAdmin",
            component: () => import("../views/myCenterView/teamView/teamOrderAdmin"),
            meta: { isCheck: true }


          },
          // 成员看的团队订单
          {
            name: "teamOrderList",
            path: "teamOrderList",
            component: () => import("../views/myCenterView/teamView/teamOrderList"),
            meta: { isCheck: true }


          },
          // 团队开票
          {
            name: "teamInvoice",
            path: "teamInvoice",
            component: () => import("../views/myCenterView/teamView/teamInvoice"),
            meta: { isCheck: true }

          },
          // 团队预存还款
          {
            name: "teamRepayment",
            path: "teamRepayment",
            component: () => import("../views/myCenterView/teamView/teamRepayment"),
            meta: { isCheck: true }

          },
          // 邀请好友
          {
            name: "invitationAssistance",
            path: "invitationAssistance",
            component: () => import("../views/myCenterView/invitationAssistance"),
          },
          // 邀请记录
          {
            name: "invitationAssistanceRecords",
            path: "invitationAssistanceRecords",
            component: () => import("../views/myCenterView/invitationAssistanceRecords"),
          },
          // 邀请列表
          {
            name: "invitationAssistanceDetail",
            path: "invitationAssistanceDetail",
            component: () => import("../views/myCenterView/invitationAssistanceDetail"),
          },
          // 活动提现列表
          {
            name: "invitationAssistanceList",
            path: "invitationAssistanceList",
            component: () => import("../views/myCenterView/invitationAssistanceList"),
          }
        ]

      },


    ]
  },
  {
    path: "/Login",
    name: "Login",
    component: Login
  },
  // 绑定手机号页面
  {
    path: '/bindPhone',
    name: 'bindPhone',
    component: () => import('../views/bindPhone')
  },
  {
    path: "/Register",
    name: "Register",
    component: Register
  },

]

// 滚动条置顶
const scroll = () => {
  let app = document.getElementById('app')
  if (app) {
    app.scrollTop = 0
  }
}
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}

const router = new VueRouter({
  routes,
  scrollBehavior: () => {
    return { x: 0, y: 0 };
  },
})
// 路由前置守卫
router.beforeEach((to, form, next) => {
  // 判断是否需要登录
  // if (to.meta.loginRequest) {
  //   // 判断是否有用户信息
  //   let user = store.state.user.userInfo
  //   if (user && JSON.stringify(user) != "{}") {
  //     next()
  //     scroll()
  //   } else {
  //     // 无用户信息
  //     // 将要去的页面存储起来
  //     sessionStorage.setItem("path", to.path)
  //     // 放行至登录
  //     next("/Login")
  //     scroll()
  //   }
  // }
  const { categoryData } = store.state.home
  if (!categoryData.length) {
    store.dispatch('home/getCategory')
  }
  console.log('123123');

  next()
  scroll()

})
router.afterEach((to) => {
  const { isCount, title } = to.meta
  if (isCount) {
    userCount(title)
  }
})
export default router
